// import React, { useState, useEffect, useRef } from 'react';
// import { useNavigate } from 'react-router-dom';
// import authService from '../../services/authService';
// import customerService from '../../services/customerService';
// import routeService from '../../services/routeService';
// import GeolocationService from '../../services/geolocationService';
// import ToastService from '../../services/toastService';
// import Sidebar from '../Sidebar/Sidebar';
//
// const Customers = () => {
//   const navigate = useNavigate();
//   const [showSidebar, setShowSidebar] = useState(false);
//   const [showModal, setShowModal] = useState(false);
//   const [customers, setCustomers] = useState([]);
//   const [loading, setLoading] = useState({
//     customers: false,
//     submitting: false
//   });
//   const [pagination, setPagination] = useState({
//     currentPage: 1,
//     totalPages: 1,
//     total: 0,
//     limit: 10,
//     hasNextPage: false,
//     hasPrevPage: false
//   });
//   const [searchTerm, setSearchTerm] = useState('');
//   const [searchInput, setSearchInput] = useState('');
//   const [routeInfo, setRouteInfo] = useState(null);
//   const [shiftActive, setShiftActive] = useState(false);
//   const [modalMode, setModalMode] = useState('add');
//   const [selectedCustomer, setSelectedCustomer] = useState(null);
//
//   // Pull to refresh states
//   const [refreshing, setRefreshing] = useState(false);
//   const [pullDistance, setPullDistance] = useState(0);
//   const touchStartY = useRef(0);
//   const containerRef = useRef(null);
//   const searchTimeoutRef = useRef(null);
//
//   // Form state
//   const [formData, setFormData] = useState({
//     name: '',
//     shopName: '',
//     lane: '',
//     town: '',
//     province: '',
//     contactNumber: '',
//     email: '',
//     birthday: '',
//     creditLimit: 0,
//     lat: '',
//     lon: '',
//     routeId: '',
//     isActive: true
//   });
//
//   useEffect(() => {
//     // Check authentication
//     if (!authService.isAuthenticated()) {
//       ToastService.error('Session expired. Please login again.');
//       navigate('/login');
//       return;
//     }
//
//     // Check if shift is active and get routeId
//     checkShiftStatus();
//   }, [navigate]);
//
//   useEffect(() => {
//     if (shiftActive && routeInfo?.id) {
//       fetchCustomers();
//     }
//   }, [shiftActive, routeInfo?.id, pagination.currentPage, searchTerm]);
//
//   // Debounced search
//   useEffect(() => {
//     if (searchTimeoutRef.current) {
//       clearTimeout(searchTimeoutRef.current);
//     }
//
//     searchTimeoutRef.current = setTimeout(() => {
//       setSearchTerm(searchInput);
//       setPagination(prev => ({ ...prev, currentPage: 1 }));
//     }, 500);
//
//     return () => {
//       if (searchTimeoutRef.current) {
//         clearTimeout(searchTimeoutRef.current);
//       }
//     };
//   }, [searchInput]);
//
//   // Pull to refresh handlers
//   const handleTouchStart = (e) => {
//     if (containerRef.current && containerRef.current.scrollTop === 0) {
//       touchStartY.current = e.touches[0].clientY;
//     }
//   };
//
//   const handleTouchMove = (e) => {
//     if (refreshing) return;
//
//     const touchY = e.touches[0].clientY;
//     const pull = touchY - touchStartY.current;
//
//     if (pull > 0 && containerRef.current && containerRef.current.scrollTop === 0) {
//       e.preventDefault();
//       setPullDistance(Math.min(pull, 100));
//     }
//   };
//
//   const handleTouchEnd = () => {
//     if (pullDistance > 60) {
//       handleRefresh();
//     }
//     setPullDistance(0);
//   };
//
//   const handleRefresh = async () => {
//     setRefreshing(true);
//     try {
//       await fetchCustomers();
//       ToastService.success('Customers refreshed', 1500);
//     } catch (error) {
//       ToastService.error('Refresh failed');
//     } finally {
//       setTimeout(() => setRefreshing(false), 500);
//     }
//   };
//
//   const checkShiftStatus = () => {
//     const shiftDataStr = localStorage.getItem('current_shift');
//
//     if (shiftDataStr) {
//       const shiftData = JSON.parse(shiftDataStr);
//
//       if (shiftData.isActive && shiftData.routeId) {
//         setShiftActive(true);
//         setRouteInfo({
//           id: shiftData.routeId,
//           name: shiftData.routeName || 'Current Route'
//         });
//
//         const routeName = localStorage.getItem('currentRouteName');
//         if (routeName) {
//           setRouteInfo(prev => ({ ...prev, name: routeName }));
//         }
//
//         setFormData(prev => ({ ...prev, routeId: shiftData.routeId }));
//         fetchRouteDetails(shiftData.routeId);
//       } else {
//         setShiftActive(false);
//         setRouteInfo(null);
//       }
//     } else {
//       setShiftActive(false);
//       setRouteInfo(null);
//     }
//
//     setLoading({ customers: false, submitting: false });
//   };
//
//   const fetchRouteDetails = async (routeId) => {
//     try {
//       const response = await routeService.getRouteById(routeId);
//       if (response.success) {
//         setRouteInfo(prev => ({
//           ...prev,
//           name: response.data.name || prev.name
//         }));
//       }
//     } catch (error) {
//       console.warn('Could not fetch route details:', error.message);
//     }
//   };
//
//   const fetchCustomers = async () => {
//     try {
//       setLoading(prev => ({ ...prev, customers: true }));
//
//       const response = await customerService.getCustomersByRoute(
//         routeInfo.id,
//         pagination.currentPage,
//         pagination.limit,
//         searchTerm
//       );
//
//       if (response.success) {
//         setCustomers(response.data);
//         setPagination({
//           currentPage: response.pagination.page,
//           totalPages: response.pagination.totalPages,
//           total: response.pagination.total,
//           limit: response.pagination.limit,
//           hasNextPage: response.pagination.hasNextPage,
//           hasPrevPage: response.pagination.hasPrevPage
//         });
//       } else {
//         setCustomers([]);
//         setPagination(prev => ({
//           ...prev,
//           totalPages: 0,
//           total: 0,
//           hasNextPage: false,
//           hasPrevPage: false
//         }));
//       }
//     } catch (error) {
//       console.error('Error fetching customers:', error);
//       setCustomers([]);
//       setPagination(prev => ({
//         ...prev,
//         totalPages: 0,
//         total: 0,
//         hasNextPage: false,
//         hasPrevPage: false
//       }));
//
//       if (error.message.includes('401') || error.message.includes('Unauthorized')) {
//         ToastService.error('Session expired. Please login again.');
//         navigate('/login');
//       } else if (!error.message.includes('404')) {
//         ToastService.error('Failed to load customers. Please try again.');
//       }
//     } finally {
//       setLoading(prev => ({ ...prev, customers: false }));
//     }
//   };
//
//   const handleSearch = (e) => {
//     setSearchInput(e.target.value);
//   };
//
//   const handlePageChange = (page) => {
//     if (page >= 1 && page <= pagination.totalPages) {
//       setPagination(prev => ({ ...prev, currentPage: page }));
//
//       // Scroll to top on page change
//       if (containerRef.current) {
//         containerRef.current.scrollTo({ top: 0, behavior: 'smooth' });
//       }
//     }
//   };
//
//   const handleFormChange = (e) => {
//     const { name, value, type, checked } = e.target;
//
//     if (name === 'isActive' && modalMode === 'edit') {
//       ToastService.info('Status cannot be changed in edit mode.', 'info', 2000);
//       return;
//     }
//
//     setFormData(prev => ({
//       ...prev,
//       [name]: type === 'checkbox' ? checked : value
//     }));
//   };
//
//   const handleGetLocation = async () => {
//     try {
//       setLoading(prev => ({ ...prev, submitting: true }));
//
//       const location = await GeolocationService.getCurrentLocation();
//
//       setFormData(prev => ({
//         ...prev,
//         lat: location.lat,
//         lon: location.lon
//       }));
//
//       ToastService.success(`Location captured: ${location.lat}, ${location.lon}`, 'success', 3000);
//     } catch (error) {
//       ToastService.error(error.message, 'error', 4000);
//     } finally {
//       setLoading(prev => ({ ...prev, submitting: false }));
//     }
//   };
//
//   const handleOpenAddModal = () => {
//     if (!shiftActive) {
//       ToastService.error('Please start a shift first to add customers.', 'error', 3000);
//       return;
//     }
//
//     setModalMode('add');
//     setSelectedCustomer(null);
//
//     setFormData({
//       name: '',
//       shopName: '',
//       lane: '',
//       town: '',
//       province: '',
//       contactNumber: '',
//       email: '',
//       birthday: '',
//       creditLimit: 0,
//       lat: '',
//       lon: '',
//       routeId: routeInfo.id,
//       isActive: true
//     });
//
//     setShowModal(true);
//   };
//
//   const handleOpenEditModal = (customer) => {
//     if (!shiftActive) {
//       ToastService.error('Please start a shift first to edit customers.', 'error', 3000);
//       return;
//     }
//
//     setModalMode('edit');
//     setSelectedCustomer(customer);
//
//     setFormData({
//       name: customer.name || '',
//       shopName: customer.shopName || '',
//       lane: customer.lane || '',
//       town: customer.town || '',
//       province: customer.province || '',
//       contactNumber: customer.contactNumber || '',
//       email: customer.email || '',
//       birthday: customer.birthday ? customer.birthday.split('T')[0] : '',
//       creditLimit: customer.creditLimit || 0,
//       lat: customer.lat || '',
//       lon: customer.lon || '',
//       routeId: customer.routeId || routeInfo.id,
//       isActive: customer.isActive !== false
//     });
//
//     setShowModal(true);
//   };
//
//   const handleCloseModal = () => {
//     setShowModal(false);
//     setSelectedCustomer(null);
//     setFormData({
//       name: '',
//       shopName: '',
//       lane: '',
//       town: '',
//       province: '',
//       contactNumber: '',
//       email: '',
//       birthday: '',
//       creditLimit: 0,
//       lat: '',
//       lon: '',
//       routeId: routeInfo?.id || '',
//       isActive: true
//     });
//   };
//
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//
//     try {
//       setLoading(prev => ({ ...prev, submitting: true }));
//
//       const submitData = {
//         ...formData,
//         creditLimit: parseFloat(formData.creditLimit) || 0,
//         lat: formData.lat || null,
//         lon: formData.lon || null
//       };
//
//       let response;
//
//       if (modalMode === 'add') {
//         response = await customerService.createCustomer(submitData);
//       } else {
//         response = await customerService.updateCustomer(selectedCustomer.id, submitData);
//       }
//
//       if (response.success) {
//         ToastService.success(
//           modalMode === 'add'
//             ? 'Customer added successfully!'
//             : 'Customer updated successfully!',
//           'success',
//           3000
//         );
//
//         handleCloseModal();
//         fetchCustomers();
//       } else {
//         ToastService.error(response.message || 'Operation failed', 'error', 4000);
//       }
//     } catch (error) {
//       ToastService.error(error.message || 'Failed to save customer', 'error', 4000);
//     } finally {
//       setLoading(prev => ({ ...prev, submitting: false }));
//     }
//   };
//
//   const formatCurrency = (amount) => {
//     const num = Number(amount);
//     return `Rs.${num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
//   };
//
//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
//
//     try {
//       const date = new Date(dateString);
//       return date.toLocaleDateString('en-US', {
//         month: 'short',
//         day: 'numeric',
//         year: 'numeric'
//       });
//     } catch (error) {
//       return 'N/A';
//     }
//   };
//
//   const handleViewOnMap = (lat, lon) => {
//     if (!lat || !lon) {
//       ToastService.info('No location data available for this customer.', 'info', 3000);
//       return;
//     }
//
//     const mapsUrl = `https://www.google.com/maps?q=${lat},${lon}`;
//     window.open(mapsUrl, '_blank');
//   };
//
//   const handleStartShift = () => {
//     navigate('/dashboard');
//     ToastService.info('Please start a shift first to manage customers', 'info', 3000);
//   };
//
//   return (
//     <div
//       ref={containerRef}
//       className="min-h-screen bg-gray-50 overflow-y-auto"
//       onTouchStart={handleTouchStart}
//       onTouchMove={handleTouchMove}
//       onTouchEnd={handleTouchEnd}
//     >
//       <Sidebar isOpen={showSidebar} onClose={() => setShowSidebar(false)} />
//
//       {showSidebar && (
//         <div
//           className="fixed inset-0 bg-black/50 z-40 lg:hidden transition-opacity"
//           onClick={() => setShowSidebar(false)}
//         />
//       )}
//
//       {/* Pull to Refresh Indicator */}
//       {pullDistance > 0 && (
//         <div
//           className="fixed top-0 left-0 right-0 flex items-center justify-center transition-all duration-200 z-50"
//           style={{
//             transform: `translateY(${pullDistance}px)`,
//             opacity: pullDistance / 100
//           }}
//         >
//           <div className={`bg-white rounded-full p-2 shadow-lg ${refreshing ? 'animate-spin' : ''}`}>
//             <svg
//               className="w-5 h-5 text-blue-600"
//               fill="none"
//               stroke="currentColor"
//               viewBox="0 0 24 24"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth={2}
//                 d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
//               />
//             </svg>
//           </div>
//         </div>
//       )}
//
//       {/* Header */}
//       <header className="sticky top-0 z-30 bg-gradient-to-r from-[#0613cc] to-[#0613cc] shadow-lg">
//         <div className="px-4 sm:px-6 lg:px-8">
//           <div className="flex items-center justify-between h-16">
//             <div className="flex items-center gap-3 sm:gap-4">
//               <button
//                 className="p-2 -ml-2 text-white/80 hover:text-white hover:bg-white/10 rounded-lg transition-colors lg:hidden"
//                 onClick={() => setShowSidebar(true)}
//               >
//                 <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
//                 </svg>
//               </button>
//               <h1 className="text-lg sm:text-xl font-semibold text-white">Customer Management</h1>
//             </div>
//
//             {routeInfo && (
//               <span className="hidden sm:flex items-center gap-2 px-3 py-1.5 rounded-full text-xs sm:text-sm font-medium bg-white/20 text-white">
//                 <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
//                 </svg>
//                 {routeInfo.name}
//               </span>
//             )}
//           </div>
//         </div>
//       </header>
//
//       {/* Main Content */}
//       <main className="px-4 sm:px-6 lg:px-8 py-6 sm:py-8 max-w-7xl mx-auto">
//
//         {!shiftActive ? (
//           <div className="rounded-2xl shadow-lg p-8 sm:p-12 text-center bg-white">
//             <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-gradient-to-br from-blue-100 to-blue-200 flex items-center justify-center">
//               <svg className="w-10 h-10 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
//               </svg>
//             </div>
//             <h3 className="text-2xl font-bold text-gray-900 mb-3">Shift Not Started</h3>
//             <p className="text-gray-600 mb-6 max-w-md mx-auto">
//               You need to start a shift first to manage customers.
//             </p>
//             <button
//               className="px-6 py-3 rounded-lg font-semibold text-white transition-all transform hover:scale-105 active:scale-95 shadow-lg"
//               style={{ background: 'linear-gradient(135deg, #0613cc, #0613cc)' }}
//               onClick={handleStartShift}
//             >
//               <span className="flex items-center gap-2">
//                 <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//                 </svg>
//                 Go to Dashboard to Start Shift
//               </span>
//             </button>
//           </div>
//         ) : (
//           <>
//             {/* Add Customer Button */}
//             <div className="mb-6">
//               <button
//                 className="w-full sm:w-auto px-6 py-3 rounded-lg font-semibold text-white shadow-lg transition-all transform hover:scale-105 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
//                 style={{ background: 'linear-gradient(135deg, #0613cc, #0613cc)' }}
//                 onClick={handleOpenAddModal}
//                 disabled={loading.customers}
//               >
//                 <svg className="w-5 h-5 inline-block mr-2 -mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
//                 </svg>
//                 Add New Customer
//               </button>
//             </div>
//
//             {/* Search and Controls */}
//             <div className="mb-6">
//               <div className="flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between">
//                 <div className="relative flex-1 max-w-md">
//                   <input
//                     type="text"
//                     placeholder="Search customers..."
//                     value={searchInput}
//                     onChange={handleSearch}
//                     disabled={loading.customers}
//                     className="w-full pl-10 pr-4 py-2.5 rounded-lg border-2 border-gray-200 bg-white text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60 disabled:cursor-not-allowed transition-all"
//                   />
//                   <svg
//                     className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
//                   </svg>
//                 </div>
//
//                 <div className="flex items-center gap-3">
//                   <button
//                     onClick={fetchCustomers}
//                     disabled={loading.customers}
//                     className="px-4 py-2.5 rounded-lg bg-white border-2 border-gray-200 text-gray-700 font-medium hover:bg-gray-50 disabled:opacity-60 disabled:cursor-not-allowed transition-all"
//                   >
//                     <svg
//                       className={`w-5 h-5 ${loading.customers ? 'animate-spin' : ''}`}
//                       fill="none"
//                       stroke="currentColor"
//                       viewBox="0 0 24 24"
//                     >
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
//                     </svg>
//                   </button>
//                 </div>
//               </div>
//
//               {/* Mobile Route Badge */}
//               {routeInfo && (
//                 <div className="sm:hidden mt-3 flex items-center gap-2 px-3 py-2 rounded-lg bg-blue-50 border border-blue-200">
//                   <svg className="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
//                   </svg>
//                   <span className="text-sm font-medium text-blue-900">{routeInfo.name}</span>
//                 </div>
//               )}
//             </div>
//
//             {/* Customer Cards */}
//             {loading.customers ? (
//               <div className="flex flex-col items-center justify-center py-20">
//                 <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4"></div>
//                 <p className="text-gray-600">Loading customer data...</p>
//               </div>
//             ) : customers.length > 0 ? (
//               <>
//                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
//                   {customers.map((customer) => (
//                     <div
//                       key={customer.id}
//                       className="bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow overflow-hidden border border-gray-100"
//                     >
//                       {/* Card Header */}
//                       <div className="bg-gradient-to-r from-[#0613cc] to-[#0613cc] px-4 py-3 flex items-center justify-between">
//                         <span className="text-xs font-medium text-white/80">ID: {customer.id}</span>
//                         <span className={`px-2 py-1 rounded-full text-xs font-medium ${
//                           customer.isActive
//                             ? 'bg-green-100 text-green-700'
//                             : 'bg-gray-100 text-gray-600'
//                         }`}>
//                           {customer.isActive ? 'Active' : 'Inactive'}
//                         </span>
//                       </div>
//
//                       {/* Card Body */}
//                       <div className="p-4 space-y-4">
//                         {/* Name & Shop */}
//                         <div>
//                           <div className="flex items-center gap-2 mb-2">
//                             <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
//                             </svg>
//                             <span className="text-xs text-gray-500 font-medium">Customer Name</span>
//                           </div>
//                           <p className="text-sm font-semibold text-gray-900">{customer.name}</p>
//                           {customer.shopName && (
//                             <p className="text-sm text-gray-600 mt-1">{customer.shopName}</p>
//                           )}
//                         </div>
//
//                         {/* Contact */}
//                         <div>
//                           <div className="flex items-center gap-2 mb-2">
//                             <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
//                             </svg>
//                             <span className="text-xs text-gray-500 font-medium">Contact</span>
//                           </div>
//                           <p className="text-sm font-semibold text-gray-900">{customer.contactNumber}</p>
//                           {customer.email && (
//                             <p className="text-xs text-gray-600 mt-1 truncate">{customer.email}</p>
//                           )}
//                         </div>
//
//                         {/* Address */}
//                         <div>
//                           <div className="flex items-center gap-2 mb-2">
//                             <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
//                               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
//                             </svg>
//                             <span className="text-xs text-gray-500 font-medium">Address</span>
//                           </div>
//                           <p className="text-sm text-gray-900">{customer.lane}, {customer.town}</p>
//                           <p className="text-xs text-gray-600 mt-1">{customer.province}</p>
//                         </div>
//
//                         {/* Credit & Birthday */}
//                         <div className="grid grid-cols-2 gap-4 pt-3 border-t border-gray-100">
//                           <div>
//                             <div className="text-xs text-gray-500 mb-1">Credit Limit</div>
//                             <div className="text-sm font-bold text-orange-600">{formatCurrency(customer.creditLimit)}</div>
//                           </div>
//                           <div>
//                             <div className="text-xs text-gray-500 mb-1">Birthday</div>
//                             <div className="text-sm font-semibold text-gray-900">{formatDate(customer.birthday)}</div>
//                           </div>
//                         </div>
//                       </div>
//
//                       {/* Card Footer */}
//                       <div className="px-4 pb-4 flex gap-2">
//                         <button
//                           className="flex-1 px-3 py-2 rounded-lg bg-blue-600 text-white text-sm font-medium hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
//                           onClick={() => handleViewOnMap(customer.lat, customer.lon)}
//                           disabled={!customer.lat || !customer.lon}
//                         >
//                           <svg className="w-4 h-4 inline-block mr-1 -mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
//                           </svg>
//                           Map
//                         </button>
//
//                         <button
//                           className="flex-1 px-3 py-2 rounded-lg bg-indigo-600 text-white text-sm font-medium hover:bg-indigo-700 transition-colors"
//                           onClick={() => handleOpenEditModal(customer)}
//                           disabled={loading.submitting}
//                         >
//                           <svg className="w-4 h-4 inline-block mr-1 -mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
//                           </svg>
//                           Edit
//                         </button>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//
//                 {/* Pagination */}
//                 {pagination.totalPages > 1 && (
//                   <div className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-4 bg-white rounded-xl shadow-md p-4">
//                     <button
//                       onClick={() => handlePageChange(pagination.currentPage - 1)}
//                       disabled={!pagination.hasPrevPage || loading.customers}
//                       className="w-full sm:w-auto px-4 py-2.5 rounded-lg bg-gradient-to-r from-[#0613cc] to-[#0613cc] text-white font-medium hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed transition-all flex items-center justify-center gap-2"
//                     >
//                       <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
//                       </svg>
//                       Previous
//                     </button>
//
//                     <div className="text-center">
//                       <p className="text-sm font-semibold text-gray-900">
//                         Page {pagination.currentPage} of {pagination.totalPages}
//                       </p>
//                       {pagination.total > 0 && (
//                         <p className="text-xs text-gray-500 mt-1">
//                           {pagination.total} total customers
//                         </p>
//                       )}
//                     </div>
//
//                     <button
//                       onClick={() => handlePageChange(pagination.currentPage + 1)}
//                       disabled={!pagination.hasNextPage || loading.customers}
//                       className="w-full sm:w-auto px-4 py-2.5 rounded-lg bg-gradient-to-r from-[#0613cc] to-[#0613cc] text-white font-medium hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed transition-all flex items-center justify-center gap-2"
//                     >
//                       Next
//                       <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
//                       </svg>
//                     </button>
//                   </div>
//                 )}
//               </>
//             ) : (
//               <div className="rounded-2xl shadow-lg p-12 text-center bg-white">
//                 <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center">
//                   {searchTerm ? (
//                     <svg className="w-10 h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
//                     </svg>
//                   ) : (
//                     <svg className="w-10 h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
//                     </svg>
//                   )}
//                 </div>
//                 <h3 className="text-xl font-bold text-gray-900 mb-2">
//                   {searchTerm ? 'No customers found' : 'No customers'}
//                 </h3>
//                 <p className="text-gray-600">
//                   {searchTerm
//                     ? `No customers matching "${searchTerm}"`
//                     : 'No customers available on this route'}
//                 </p>
//               </div>
//             )}
//           </>
//         )}
//       </main>
//
//       {/* Customer Modal */}
//       {showModal && (
//         <div className="fixed inset-0 bg-black/50 z-50 flex items-start sm:items-center justify-center p-0 sm:p-4 overflow-y-auto">
//           <div className="bg-white w-full sm:rounded-2xl shadow-2xl sm:max-w-3xl sm:my-8 min-h-screen sm:min-h-0 max-h-screen sm:max-h-[90vh] flex flex-col">
//             {/* Modal Header - Sticky */}
//             <div
//               className="px-4 sm:px-6 py-4 sm:rounded-t-2xl flex items-center justify-between sticky top-0 z-10 shadow-sm"
//               style={{ background: 'linear-gradient(135deg, #0613cc, #0613cc)' }}
//             >
//               <div className="flex-1 min-w-0 pr-4">
//                 <h3 className="text-lg sm:text-xl font-semibold text-white truncate">
//                   {modalMode === 'add' ? 'Add New Customer' : 'Edit Customer'}
//                 </h3>
//                 {routeInfo && (
//                   <p className="text-xs sm:text-sm text-white/80 mt-1 truncate">Route: {routeInfo.name}</p>
//                 )}
//               </div>
//               <button
//                 className="w-8 h-8 sm:w-10 sm:h-10 rounded-lg bg-white/20 text-white hover:bg-white/30 transition-colors flex items-center justify-center flex-shrink-0"
//                 onClick={handleCloseModal}
//               >
//                 <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//                 </svg>
//               </button>
//             </div>
//
//             {/* Modal Body - Scrollable */}
//             <form onSubmit={handleSubmit} className="flex-1 overflow-y-auto">
//               <div className="p-4 sm:p-6">
//                 <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4 sm:mb-6">
//                   {/* Customer Name */}
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-2">
//                       Customer Name *
//                     </label>
//                     <input
//                       type="text"
//                       name="name"
//                       className="w-full px-3 sm:px-4 py-2.5 text-sm sm:text-base rounded-lg border border-gray-300 bg-gray-50 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60"
//                       value={formData.name}
//                       onChange={handleFormChange}
//                       required
//                       disabled={loading.submitting}
//                     />
//                   </div>
//
//                   {/* Shop Name */}
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-2">
//                       Shop/Business Name
//                     </label>
//                     <input
//                       type="text"
//                       name="shopName"
//                       className="w-full px-3 sm:px-4 py-2.5 text-sm sm:text-base rounded-lg border border-gray-300 bg-gray-50 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60"
//                       value={formData.shopName}
//                       onChange={handleFormChange}
//                       disabled={loading.submitting}
//                     />
//                   </div>
//
//                   {/* Contact Number */}
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-2">
//                       Contact Number *
//                     </label>
//                     <input
//                       type="tel"
//                       name="contactNumber"
//                       className="w-full px-3 sm:px-4 py-2.5 text-sm sm:text-base rounded-lg border border-gray-300 bg-gray-50 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60"
//                       value={formData.contactNumber}
//                       onChange={handleFormChange}
//                       required
//                       disabled={loading.submitting}
//                     />
//                   </div>
//
//                   {/* Email */}
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-2">
//                       Email Address
//                     </label>
//                     <input
//                       type="email"
//                       name="email"
//                       className="w-full px-3 sm:px-4 py-2.5 text-sm sm:text-base rounded-lg border border-gray-300 bg-gray-50 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60"
//                       value={formData.email}
//                       onChange={handleFormChange}
//                       disabled={loading.submitting}
//                     />
//                   </div>
//
//                   {/* Credit Limit */}
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-2">
//                       Credit Limit (Rs.)
//                     </label>
//                     <input
//                       type="number"
//                       name="creditLimit"
//                       className="w-full px-3 sm:px-4 py-2.5 text-sm sm:text-base rounded-lg border border-gray-300 bg-gray-50 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60"
//                       value={formData.creditLimit}
//                       onChange={handleFormChange}
//                       min="0"
//                       step="0.01"
//                       disabled={loading.submitting}
//                     />
//                   </div>
//
//                   {/* Birthday */}
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-2">
//                       Birthday 🎂
//                     </label>
//                     <input
//                       type="date"
//                       name="birthday"
//                       className="w-full px-3 sm:px-4 py-2.5 text-sm sm:text-base rounded-lg border border-gray-300 bg-gray-50 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60"
//                       value={formData.birthday}
//                       onChange={handleFormChange}
//                       disabled={loading.submitting}
//                     />
//                   </div>
//                 </div>
//
//                 {/* Address Section */}
//                 <div className="mb-4 sm:mb-6">
//                   <label className="block text-sm font-medium text-gray-700 mb-3">
//                     Address Details
//                   </label>
//                   <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
//                     <div>
//                       <label className="block text-xs text-gray-600 mb-2">Lane/Street *</label>
//                       <input
//                         type="text"
//                         name="lane"
//                         className="w-full px-3 sm:px-4 py-2.5 text-sm sm:text-base rounded-lg border border-gray-300 bg-gray-50 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60"
//                         value={formData.lane}
//                         onChange={handleFormChange}
//                         required
//                         disabled={loading.submitting}
//                       />
//                     </div>
//
//                     <div>
//                       <label className="block text-xs text-gray-600 mb-2">City/Town *</label>
//                       <input
//                         type="text"
//                         name="town"
//                         className="w-full px-3 sm:px-4 py-2.5 text-sm sm:text-base rounded-lg border border-gray-300 bg-gray-50 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60"
//                         value={formData.town}
//                         onChange={handleFormChange}
//                         required
//                         disabled={loading.submitting}
//                       />
//                     </div>
//
//                     <div>
//                       <label className="block text-xs text-gray-600 mb-2">Province *</label>
//                       <input
//                         type="text"
//                         name="province"
//                         className="w-full px-3 sm:px-4 py-2.5 text-sm sm:text-base rounded-lg border border-gray-300 bg-gray-50 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60"
//                         value={formData.province}
//                         onChange={handleFormChange}
//                         required
//                         disabled={loading.submitting}
//                       />
//                     </div>
//                   </div>
//                 </div>
//
//                 {/* Location Section */}
//                 <div className="mb-4 sm:mb-6">
//                   <label className="block text-sm font-medium text-gray-700 mb-2">
//                     Map Location (Coordinates)
//                   </label>
//                   <div className="flex flex-col sm:flex-row gap-2">
//                     <input
//                       type="text"
//                       className="flex-1 px-3 sm:px-4 py-2.5 text-sm sm:text-base rounded-lg border border-gray-300 bg-gray-100 text-gray-600 cursor-not-allowed"
//                       value={formData.lat && formData.lon ? `${formData.lat}, ${formData.lon}` : ''}
//                       placeholder="Click 'Get Location' to set coordinates"
//                       readOnly
//                       disabled={loading.submitting}
//                     />
//                     <button
//                       type="button"
//                       className="px-4 py-2.5 rounded-lg font-medium text-white text-sm sm:text-base shadow-md transition-all disabled:opacity-50 whitespace-nowrap"
//                       style={{ background: 'linear-gradient(135deg, #0613cc, #0613cc)' }}
//                       onClick={handleGetLocation}
//                       disabled={loading.submitting}
//                     >
//                       <svg className="w-4 h-4 sm:w-5 sm:h-5 inline-block mr-1 -mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
//                       </svg>
//                       Get Location
//                     </button>
//                   </div>
//                   <p className="text-xs text-gray-500 mt-2">
//                     {formData.lat && formData.lon
//                       ? '✓ Location captured! Customers can view this on map.'
//                       : 'Get current location to set map coordinates'}
//                   </p>
//                 </div>
//
//                 {/* Status Section */}
//                 {modalMode === 'add' ? (
//                   <div className="mb-4 sm:mb-6">
//                     <label className="flex items-center gap-2 cursor-pointer">
//                       <input
//                         type="checkbox"
//                         name="isActive"
//                         className="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
//                         checked={formData.isActive}
//                         onChange={handleFormChange}
//                         disabled={loading.submitting}
//                       />
//                       <span className="text-sm font-medium text-gray-700">Set customer as active</span>
//                     </label>
//                   </div>
//                 ) : (
//                   <div className="mb-4 sm:mb-6 p-3 bg-gray-50 rounded-lg">
//                     <div className="flex flex-col sm:flex-row sm:items-center gap-2">
//                       <span className="text-sm font-medium text-gray-700">Status:</span>
//                       <span className={`px-2 py-1 rounded-full text-xs font-medium inline-block w-fit ${
//                         selectedCustomer?.isActive
//                           ? 'bg-green-100 text-green-700'
//                           : 'bg-gray-100 text-gray-600'
//                       }`}>
//                         {selectedCustomer?.isActive ? 'Active' : 'Inactive'}
//                       </span>
//                       <span className="text-xs text-gray-500">(Status cannot be changed in edit mode)</span>
//                     </div>
//                   </div>
//                 )}
//
//                 {/* Form Actions - Sticky Bottom */}
//                 <div className="sticky bottom-0 bg-white pt-4 border-t border-gray-200 -mx-4 sm:-mx-6 px-4 sm:px-6 pb-4 sm:pb-6">
//                   <div className="flex flex-col sm:flex-row gap-3">
//                     <button
//                       type="button"
//                       className="flex-1 px-6 py-3 rounded-lg font-semibold text-gray-700 bg-gray-200 hover:bg-gray-300 transition-colors disabled:opacity-50 text-sm sm:text-base"
//                       onClick={handleCloseModal}
//                       disabled={loading.submitting}
//                     >
//                       Cancel
//                     </button>
//
//                     <button
//                       type="submit"
//                       className="flex-1 px-6 py-3 rounded-lg font-semibold text-white shadow-lg transition-all disabled:opacity-50 text-sm sm:text-base"
//                       style={{ background: 'linear-gradient(135deg, #0613cc, #0613cc)' }}
//                       disabled={loading.submitting}
//                     >
//                       {loading.submitting ? (
//                         <>
//                           <svg className="w-4 h-4 sm:w-5 sm:h-5 inline-block mr-2 -mt-0.5 animate-spin" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
//                           </svg>
//                           Saving...
//                         </>
//                       ) : (
//                         <>
//                           <svg className="w-4 h-4 sm:w-5 sm:h-5 inline-block mr-2 -mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4" />
//                           </svg>
//                           Save Customer
//                         </>
//                       )}
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };
//
// export default Customers;

import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import authService from '../../services/authService';
import customerService from '../../services/customerService';
import routeService from '../../services/routeService';
import GeolocationService from '../../services/geolocationService';
import ToastService from '../../services/toastService';
import Sidebar from '../Sidebar/Sidebar';

const Customers = () => {
    const navigate = useNavigate();
    const [showSidebar, setShowSidebar] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [customers, setCustomers] = useState([]);
    const [loading, setLoading] = useState({
        customers: false,
        submitting: false
    });
    const [pagination, setPagination] = useState({
        currentPage: 1,
        totalPages: 1,
        total: 0,
        limit: 10,
        hasNextPage: false,
        hasPrevPage: false
    });
    const [searchTerm, setSearchTerm] = useState('');
    const [searchInput, setSearchInput] = useState('');
    const [routeInfo, setRouteInfo] = useState(null);
    const [shiftActive, setShiftActive] = useState(false);
    const [modalMode, setModalMode] = useState('add');
    const [selectedCustomer, setSelectedCustomer] = useState(null);

    const searchTimeoutRef = useRef(null);

    // Form state
    const [formData, setFormData] = useState({
        name: '',
        shopName: '',
        lane: '',
        town: '',
        province: '',
        contactNumber: '',
        email: '',
        birthday: '',
        creditLimit: 0,
        lat: '',
        lon: '',
        routeId: '',
        isActive: true
    });

    useEffect(() => {
        // Check authentication
        if (!authService.isAuthenticated()) {
            ToastService.error('Session expired. Please login again.');
            navigate('/login');
            return;
        }

        // Check if shift is active and get routeId
        checkShiftStatus();
    }, [navigate]);

    useEffect(() => {
        if (shiftActive && routeInfo?.id) {
            fetchCustomers();
        }
    }, [shiftActive, routeInfo?.id, pagination.currentPage, searchTerm]);

    // Debounced search
    useEffect(() => {
        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }

        searchTimeoutRef.current = setTimeout(() => {
            setSearchTerm(searchInput);
            setPagination(prev => ({ ...prev, currentPage: 1 }));
        }, 500);

        return () => {
            if (searchTimeoutRef.current) {
                clearTimeout(searchTimeoutRef.current);
            }
        };
    }, [searchInput]);

    const checkShiftStatus = () => {
        const shiftDataStr = localStorage.getItem('current_shift');

        if (shiftDataStr) {
            const shiftData = JSON.parse(shiftDataStr);

            if (shiftData.isActive && shiftData.routeId) {
                setShiftActive(true);
                setRouteInfo({
                    id: shiftData.routeId,
                    name: shiftData.routeName || 'Current Route'
                });

                const routeName = localStorage.getItem('currentRouteName');
                if (routeName) {
                    setRouteInfo(prev => ({ ...prev, name: routeName }));
                }

                setFormData(prev => ({ ...prev, routeId: shiftData.routeId }));
                fetchRouteDetails(shiftData.routeId);
            } else {
                setShiftActive(false);
                setRouteInfo(null);
            }
        } else {
            setShiftActive(false);
            setRouteInfo(null);
        }

        setLoading({ customers: false, submitting: false });
    };

    const fetchRouteDetails = async (routeId) => {
        try {
            const response = await routeService.getRouteById(routeId);
            if (response.success) {
                setRouteInfo(prev => ({
                    ...prev,
                    name: response.data.name || prev.name
                }));
            }
        } catch (error) {
            console.warn('Could not fetch route details:', error.message);
        }
    };

    const fetchCustomers = async () => {
        try {
            setLoading(prev => ({ ...prev, customers: true }));

            const response = await customerService.getCustomersByRoute(
                routeInfo.id,
                pagination.currentPage,
                pagination.limit,
                searchTerm
            );

            if (response.success) {
                setCustomers(response.data);
                setPagination({
                    currentPage: response.pagination.page,
                    totalPages: response.pagination.totalPages,
                    total: response.pagination.total,
                    limit: response.pagination.limit,
                    hasNextPage: response.pagination.hasNextPage,
                    hasPrevPage: response.pagination.hasPrevPage
                });
            } else {
                setCustomers([]);
                setPagination(prev => ({
                    ...prev,
                    totalPages: 0,
                    total: 0,
                    hasNextPage: false,
                    hasPrevPage: false
                }));
            }
        } catch (error) {
            console.error('Error fetching customers:', error);
            setCustomers([]);
            setPagination(prev => ({
                ...prev,
                totalPages: 0,
                total: 0,
                hasNextPage: false,
                hasPrevPage: false
            }));

            if (error.message.includes('401') || error.message.includes('Unauthorized')) {
                ToastService.error('Session expired. Please login again.');
                navigate('/login');
            } else if (!error.message.includes('404')) {
                ToastService.error('Failed to load customers. Please try again.');
            }
        } finally {
            setLoading(prev => ({ ...prev, customers: false }));
        }
    };

    const handleSearch = (e) => {
        setSearchInput(e.target.value);
    };

    const handlePageChange = (page) => {
        if (page >= 1 && page <= pagination.totalPages) {
            setPagination(prev => ({ ...prev, currentPage: page }));

            // Scroll to top on page change
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    const handleFormChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (name === 'isActive' && modalMode === 'edit') {
            ToastService.info('Status cannot be changed in edit mode.', 'info', 2000);
            return;
        }

        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleGetLocation = async () => {
        try {
            setLoading(prev => ({ ...prev, submitting: true }));

            const location = await GeolocationService.getCurrentLocation();

            setFormData(prev => ({
                ...prev,
                lat: location.lat,
                lon: location.lon
            }));

            ToastService.success(`Location captured: ${location.lat}, ${location.lon}`, 'success', 3000);
        } catch (error) {
            ToastService.error(error.message, 'error', 4000);
        } finally {
            setLoading(prev => ({ ...prev, submitting: false }));
        }
    };

    const handleOpenAddModal = () => {
        if (!shiftActive) {
            ToastService.error('Please start a shift first to add customers.', 'error', 3000);
            return;
        }

        setModalMode('add');
        setSelectedCustomer(null);

        setFormData({
            name: '',
            shopName: '',
            lane: '',
            town: '',
            province: '',
            contactNumber: '',
            email: '',
            birthday: '',
            creditLimit: 0,
            lat: '',
            lon: '',
            routeId: routeInfo.id,
            isActive: true
        });

        setShowModal(true);
    };

    const handleOpenEditModal = (customer) => {
        if (!shiftActive) {
            ToastService.error('Please start a shift first to edit customers.', 'error', 3000);
            return;
        }

        setModalMode('edit');
        setSelectedCustomer(customer);

        setFormData({
            name: customer.name || '',
            shopName: customer.shopName || '',
            lane: customer.lane || '',
            town: customer.town || '',
            province: customer.province || '',
            contactNumber: customer.contactNumber || '',
            email: customer.email || '',
            birthday: customer.birthday ? customer.birthday.split('T')[0] : '',
            creditLimit: customer.creditLimit || 0,
            lat: customer.lat || '',
            lon: customer.lon || '',
            routeId: customer.routeId || routeInfo.id,
            isActive: customer.isActive !== false
        });

        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedCustomer(null);
        setFormData({
            name: '',
            shopName: '',
            lane: '',
            town: '',
            province: '',
            contactNumber: '',
            email: '',
            birthday: '',
            creditLimit: 0,
            lat: '',
            lon: '',
            routeId: routeInfo?.id || '',
            isActive: true
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            setLoading(prev => ({ ...prev, submitting: true }));

            const submitData = {
                ...formData,
                creditLimit: parseFloat(formData.creditLimit) || 0,
                lat: formData.lat || null,
                lon: formData.lon || null
            };

            let response;

            if (modalMode === 'add') {
                response = await customerService.createCustomer(submitData);
            } else {
                response = await customerService.updateCustomer(selectedCustomer.id, submitData);
            }

            if (response.success) {
                ToastService.success(
                    modalMode === 'add'
                        ? 'Customer added successfully!'
                        : 'Customer updated successfully!',
                    'success',
                    3000
                );

                handleCloseModal();
                fetchCustomers();
            } else {
                ToastService.error(response.message || 'Operation failed', 'error', 4000);
            }
        } catch (error) {
            ToastService.error(error.message || 'Failed to save customer', 'error', 4000);
        } finally {
            setLoading(prev => ({ ...prev, submitting: false }));
        }
    };

    const formatCurrency = (amount) => {
        const num = Number(amount);
        return `Rs.${num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';

        try {
            const date = new Date(dateString);
            return date.toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            });
        } catch (error) {
            return 'N/A';
        }
    };

    const handleViewOnMap = (lat, lon) => {
        if (!lat || !lon) {
            ToastService.info('No location data available for this customer.', 'info', 3000);
            return;
        }

        const mapsUrl = `https://www.google.com/maps?q=${lat},${lon}`;
        window.open(mapsUrl, '_blank');
    };

    const handleStartShift = () => {
        navigate('/dashboard');
        ToastService.info('Please start a shift first to manage customers', 'info', 3000);
    };

    return (
        <div
            className="min-h-screen bg-gray-50 overflow-y-auto"
        >
            <Sidebar isOpen={showSidebar} onClose={() => setShowSidebar(false)} />

            {showSidebar && (
                <div
                    className="fixed inset-0 bg-black/50 z-40 lg:hidden transition-opacity"
                    onClick={() => setShowSidebar(false)}
                />
            )}

            {/* Header */}
            <header className="sticky top-0 z-30 bg-gradient-to-r from-[#0613cc] to-[#0613cc] shadow-lg">
                <div className="px-4 sm:px-6 lg:px-8">
                    <div className="flex items-center justify-between h-16">
                        <div className="flex items-center gap-3 sm:gap-4">
                            <button
                                className="p-2 -ml-2 text-white/80 hover:text-white hover:bg-white/10 rounded-lg transition-colors lg:hidden"
                                onClick={() => setShowSidebar(true)}
                            >
                                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                                </svg>
                            </button>
                            <h1 className="text-lg sm:text-xl font-semibold text-white">Customer Management</h1>
                        </div>

                        {routeInfo && (
                            <span className="hidden sm:flex items-center gap-2 px-3 py-1.5 rounded-full text-xs sm:text-sm font-medium bg-white/20 text-white">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
                </svg>
                                {routeInfo.name}
              </span>
                        )}
                    </div>
                </div>
            </header>

            {/* Main Content */}
            <main className="px-4 sm:px-6 lg:px-8 py-6 sm:py-8 max-w-7xl mx-auto">

                {!shiftActive ? (
                    <div className="rounded-2xl shadow-lg p-8 sm:p-12 text-center bg-white">
                        <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-gradient-to-br from-blue-100 to-blue-200 flex items-center justify-center">
                            <svg className="w-10 h-10 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                        </div>
                        <h3 className="text-2xl font-bold text-gray-900 mb-3">Shift Not Started</h3>
                        <p className="text-gray-600 mb-6 max-w-md mx-auto">
                            You need to start a shift first to manage customers.
                        </p>
                        <button
                            className="px-6 py-3 rounded-lg font-semibold text-white transition-all transform hover:scale-105 active:scale-95 shadow-lg"
                            style={{ background: 'linear-gradient(135deg, #0613cc, #0613cc)' }}
                            onClick={handleStartShift}
                        >
              <span className="flex items-center gap-2">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Go to Dashboard to Start Shift
              </span>
                        </button>
                    </div>
                ) : (
                    <>
                        {/* Add Customer Button */}
                        <div className="mb-6">
                            <button
                                className="w-full sm:w-auto px-6 py-3 rounded-lg font-semibold text-white shadow-lg transition-all transform hover:scale-105 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
                                style={{ background: 'linear-gradient(135deg, #0613cc, #0613cc)' }}
                                onClick={handleOpenAddModal}
                                disabled={loading.customers}
                            >
                                <svg className="w-5 h-5 inline-block mr-2 -mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                                </svg>
                                Add New Customer
                            </button>
                        </div>

                        {/* Search and Controls */}
                        <div className="mb-6">
                            <div className="flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between">
                                <div className="relative flex-1 max-w-md">
                                    <input
                                        type="text"
                                        placeholder="Search customers..."
                                        value={searchInput}
                                        onChange={handleSearch}
                                        disabled={loading.customers}
                                        className="w-full pl-10 pr-4 py-2.5 rounded-lg border-2 border-gray-200 bg-white text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60 disabled:cursor-not-allowed transition-all"
                                    />
                                    <svg
                                        className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                    </svg>
                                </div>

                                <div className="flex items-center gap-3">
                                    <button
                                        onClick={fetchCustomers}
                                        disabled={loading.customers}
                                        className="px-4 py-2.5 rounded-lg bg-white border-2 border-gray-200 text-gray-700 font-medium hover:bg-gray-50 disabled:opacity-60 disabled:cursor-not-allowed transition-all"
                                    >
                                        <svg
                                            className={`w-5 h-5 ${loading.customers ? 'animate-spin' : ''}`}
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                        >
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                                        </svg>
                                    </button>
                                </div>
                            </div>

                            {/* Mobile Route Badge */}
                            {routeInfo && (
                                <div className="sm:hidden mt-3 flex items-center gap-2 px-3 py-2 rounded-lg bg-blue-50 border border-blue-200">
                                    <svg className="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
                                    </svg>
                                    <span className="text-sm font-medium text-blue-900">{routeInfo.name}</span>
                                </div>
                            )}
                        </div>

                        {/* Customer Cards */}
                        {loading.customers ? (
                            <div className="flex flex-col items-center justify-center py-20">
                                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4"></div>
                                <p className="text-gray-600">Loading customer data...</p>
                            </div>
                        ) : customers.length > 0 ? (
                            <>
                                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
                                    {customers.map((customer) => (
                                        <div
                                            key={customer.id}
                                            className="bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow overflow-hidden border border-gray-100"
                                        >
                                            {/* Card Header */}
                                            <div className="bg-gradient-to-r from-[#0613cc] to-[#0613cc] px-4 py-3 flex items-center justify-between">
                                                <span className="text-xs font-medium text-white/80">ID: {customer.id}</span>
                                                <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                                                    customer.isActive
                                                        ? 'bg-green-100 text-black-700'
                                                        : 'bg-gray-100 text-red-600'
                                                }`}>
                          {customer.isActive ? 'Active' : 'Inactive'}
                        </span>
                                            </div>

                                            {/* Card Body */}
                                            <div className="p-4 space-y-4">
                                                {/* Name & Shop */}
                                                <div>
                                                    <div className="flex items-center gap-2 mb-2">
                                                        <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                                        </svg>
                                                        <span className="text-xs text-gray-500 font-medium">Customer Name</span>
                                                    </div>
                                                    <p className="text-sm font-semibold text-gray-900">{customer.name}</p>
                                                    {customer.shopName && (
                                                        <p className="text-sm text-gray-600 mt-1">{customer.shopName}</p>
                                                    )}
                                                </div>

                                                {/* Contact */}
                                                <div>
                                                    <div className="flex items-center gap-2 mb-2">
                                                        <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                                                        </svg>
                                                        <span className="text-xs text-gray-500 font-medium">Contact</span>
                                                    </div>
                                                    <p className="text-sm font-semibold text-gray-900">{customer.contactNumber}</p>
                                                    {customer.email && (
                                                        <p className="text-xs text-gray-600 mt-1 truncate">{customer.email}</p>
                                                    )}
                                                </div>

                                                {/* Address */}
                                                <div>
                                                    <div className="flex items-center gap-2 mb-2">
                                                        <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                                        </svg>
                                                        <span className="text-xs text-gray-500 font-medium">Address</span>
                                                    </div>
                                                    <p className="text-sm text-gray-900">{customer.lane}, {customer.town}</p>
                                                    <p className="text-xs text-gray-600 mt-1">{customer.province}</p>
                                                </div>

                                                {/* Credit & Birthday */}
                                                <div className="grid grid-cols-2 gap-4 pt-3 border-t border-gray-100">
                                                    <div>
                                                        <div className="text-xs text-gray-500 mb-1">Credit Limit</div>
                                                        <div className="text-sm font-bold text-orange-600">{formatCurrency(customer.creditLimit)}</div>
                                                    </div>
                                                    <div>
                                                        <div className="text-xs text-gray-500 mb-1">Birthday</div>
                                                        <div className="text-sm font-semibold text-gray-900">{formatDate(customer.birthday)}</div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Card Footer */}
                                            <div className="px-4 pb-4 flex gap-2">
                                                <button
                                                    className="flex-1 px-3 py-2 rounded-lg bg-blue-800 text-white text-sm font-medium hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                                                    onClick={() => handleViewOnMap(customer.lat, customer.lon)}
                                                    disabled={!customer.lat || !customer.lon}
                                                >
                                                    <svg className="w-4 h-4 inline-block mr-1 -mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
                                                    </svg>
                                                    Map
                                                </button>

                                                <button
                                                    className="flex-1 px-3 py-2 rounded-lg bg-blue-800  text-white text-sm font-medium hover:bg-indigo-700 transition-colors"
                                                    onClick={() => handleOpenEditModal(customer)}
                                                    disabled={loading.submitting}
                                                >
                                                    <svg className="w-4 h-4 inline-block mr-1 -mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                                    </svg>
                                                    Edit
                                                </button>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                {/* Pagination */}
                                {pagination.totalPages > 1 && (
                                    <div className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-4 bg-white rounded-xl shadow-md p-4">
                                        <button
                                            onClick={() => handlePageChange(pagination.currentPage - 1)}
                                            disabled={!pagination.hasPrevPage || loading.customers}
                                            className="w-full sm:w-auto px-4 py-2.5 rounded-lg bg-gradient-to-r from-[##22c497] to-[##22c497] text-white font-medium hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed transition-all flex items-center justify-center gap-2"
                                        >
                                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                                            </svg>
                                            Previous
                                        </button>

                                        <div className="text-center">
                                            <p className="text-sm font-semibold text-gray-900">
                                                Page {pagination.currentPage} of {pagination.totalPages}
                                            </p>
                                            {pagination.total > 0 && (
                                                <p className="text-xs text-gray-500 mt-1">
                                                    {pagination.total} total customers
                                                </p>
                                            )}
                                        </div>

                                        <button
                                            onClick={() => handlePageChange(pagination.currentPage + 1)}
                                            disabled={!pagination.hasNextPage || loading.customers}
                                            className="w-full sm:w-auto px-4 py-2.5 rounded-lg bg-gradient-to-r from-[#0613cc] to-[#0613cc] text-white font-medium hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed transition-all flex items-center justify-center gap-2"
                                        >
                                            Next
                                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                            </svg>
                                        </button>
                                    </div>
                                )}
                            </>
                        ) : (
                            <div className="rounded-2xl shadow-lg p-12 text-center bg-white">
                                <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center">
                                    {searchTerm ? (
                                        <svg className="w-10 h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                        </svg>
                                    ) : (
                                        <svg className="w-10 h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                                        </svg>
                                    )}
                                </div>
                                <h3 className="text-xl font-bold text-gray-900 mb-2">
                                    {searchTerm ? 'No customers found' : 'No customers'}
                                </h3>
                                <p className="text-gray-600">
                                    {searchTerm
                                        ? `No customers matching "${searchTerm}"`
                                        : 'No customers available on this route'}
                                </p>
                            </div>
                        )}
                    </>
                )}
            </main>

            {/* Customer Modal */}
            {showModal && (
                <div className="fixed inset-0 bg-black/50 z-50 flex items-start sm:items-center justify-center p-0 sm:p-4 overflow-y-auto">
                    <div className="bg-white w-full sm:rounded-2xl shadow-2xl sm:max-w-3xl sm:my-8 min-h-screen sm:min-h-0 max-h-screen sm:max-h-[90vh] flex flex-col">
                        {/* Modal Header - Sticky */}
                        <div
                            className="px-4 sm:px-6 py-4 sm:rounded-t-2xl flex items-center justify-between sticky top-0 z-10 shadow-sm"
                            style={{ background: 'linear-gradient(135deg, #0613cc, #0613cc)' }}
                        >
                            <div className="flex-1 min-w-0 pr-4">
                                <h3 className="text-lg sm:text-xl font-semibold text-white truncate">
                                    {modalMode === 'add' ? 'Add New Customer' : 'Edit Customer'}
                                </h3>
                                {routeInfo && (
                                    <p className="text-xs sm:text-sm text-white/80 mt-1 truncate">Route: {routeInfo.name}</p>
                                )}
                            </div>
                            <button
                                className="w-8 h-8 sm:w-10 sm:h-10 rounded-lg bg-white/20 text-white hover:bg-white/30 transition-colors flex items-center justify-center flex-shrink-0"
                                onClick={handleCloseModal}
                            >
                                <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>

                        {/* Modal Body - Scrollable */}
                        <form onSubmit={handleSubmit} className="flex-1 overflow-y-auto">
                            <div className="p-4 sm:p-6">
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4 sm:mb-6">
                                    {/* Customer Name */}
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Customer Name *
                                        </label>
                                        <input
                                            type="text"
                                            name="name"
                                            className="w-full px-3 sm:px-4 py-2.5 text-sm sm:text-base rounded-lg border border-gray-300 bg-gray-50 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60"
                                            value={formData.name}
                                            onChange={handleFormChange}
                                            required
                                            disabled={loading.submitting}
                                        />
                                    </div>

                                    {/* Shop Name */}
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Shop/Business Name
                                        </label>
                                        <input
                                            type="text"
                                            name="shopName"
                                            className="w-full px-3 sm:px-4 py-2.5 text-sm sm:text-base rounded-lg border border-gray-300 bg-gray-50 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60"
                                            value={formData.shopName}
                                            onChange={handleFormChange}
                                            disabled={loading.submitting}
                                        />
                                    </div>

                                    {/* Contact Number */}
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Contact Number *
                                        </label>
                                        <input
                                            type="tel"
                                            name="contactNumber"
                                            className="w-full px-3 sm:px-4 py-2.5 text-sm sm:text-base rounded-lg border border-gray-300 bg-gray-50 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60"
                                            value={formData.contactNumber}
                                            onChange={handleFormChange}
                                            required
                                            disabled={loading.submitting}
                                        />
                                    </div>

                                    {/* Email */}
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Email Address
                                        </label>
                                        <input
                                            type="email"
                                            name="email"
                                            className="w-full px-3 sm:px-4 py-2.5 text-sm sm:text-base rounded-lg border border-gray-300 bg-gray-50 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60"
                                            value={formData.email}
                                            onChange={handleFormChange}
                                            disabled={loading.submitting}
                                        />
                                    </div>

                                    {/* Credit Limit */}
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Credit Limit (Rs.)
                                        </label>
                                        <input
                                            type="number"
                                            name="creditLimit"
                                            className="w-full px-3 sm:px-4 py-2.5 text-sm sm:text-base rounded-lg border border-gray-300 bg-gray-50 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60"
                                            value={formData.creditLimit}
                                            onChange={handleFormChange}
                                            min="0"
                                            step="0.01"
                                            disabled={loading.submitting}
                                        />
                                    </div>

                                    {/* Birthday */}
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Birthday
                                        </label>
                                        <input
                                            type="date"
                                            name="birthday"
                                            className="w-full px-3 sm:px-4 py-2.5 text-sm sm:text-base rounded-lg border border-gray-300 bg-gray-50 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60"
                                            value={formData.birthday}
                                            onChange={handleFormChange}
                                            disabled={loading.submitting}
                                        />
                                    </div>
                                </div>

                                {/* Address Section */}
                                <div className="mb-4 sm:mb-6">
                                    <label className="block text-sm font-medium text-gray-700 mb-3">
                                        Address Details
                                    </label>
                                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                                        <div>
                                            <label className="block text-xs text-gray-600 mb-2">Lane/Street *</label>
                                            <input
                                                type="text"
                                                name="lane"
                                                className="w-full px-3 sm:px-4 py-2.5 text-sm sm:text-base rounded-lg border border-gray-300 bg-gray-50 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60"
                                                value={formData.lane}
                                                onChange={handleFormChange}
                                                required
                                                disabled={loading.submitting}
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs text-gray-600 mb-2">City/Town *</label>
                                            <input
                                                type="text"
                                                name="town"
                                                className="w-full px-3 sm:px-4 py-2.5 text-sm sm:text-base rounded-lg border border-gray-300 bg-gray-50 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60"
                                                value={formData.town}
                                                onChange={handleFormChange}
                                                required
                                                disabled={loading.submitting}
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs text-gray-600 mb-2">Province *</label>
                                            <input
                                                type="text"
                                                name="province"
                                                className="w-full px-3 sm:px-4 py-2.5 text-sm sm:text-base rounded-lg border border-gray-300 bg-gray-50 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60"
                                                value={formData.province}
                                                onChange={handleFormChange}
                                                required
                                                disabled={loading.submitting}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Location Section */}
                                <div className="mb-4 sm:mb-6">
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Map Location (Coordinates)
                                    </label>
                                    <div className="flex flex-col sm:flex-row gap-2">
                                        <input
                                            type="text"
                                            className="flex-1 px-3 sm:px-4 py-2.5 text-sm sm:text-base rounded-lg border border-gray-300 bg-gray-100 text-gray-600 cursor-not-allowed"
                                            value={formData.lat && formData.lon ? `${formData.lat}, ${formData.lon}` : ''}
                                            placeholder="Click 'Get Location' to set coordinates"
                                            readOnly
                                            disabled={loading.submitting}
                                        />
                                        <button
                                            type="button"
                                            className="px-4 py-2.5 rounded-lg font-medium text-white text-sm sm:text-base shadow-md transition-all disabled:opacity-50 whitespace-nowrap"
                                            style={{ background: 'linear-gradient(135deg, #0613cc, #0613cc)' }}
                                            onClick={handleGetLocation}
                                            disabled={loading.submitting}
                                        >
                                            <svg className="w-4 h-4 sm:w-5 sm:h-5 inline-block mr-1 -mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                            </svg>
                                            Get Location
                                        </button>
                                    </div>
                                    <p className="text-xs text-gray-500 mt-2">
                                        {formData.lat && formData.lon
                                            ? '✓ Location captured! Customers can view this on map.'
                                            : 'Get current location to set map coordinates'}
                                    </p>
                                </div>

                                {/* Status Section */}
                                {modalMode === 'add' ? (
                                    <div className="mb-4 sm:mb-6">
                                        <label className="flex items-center gap-2 cursor-pointer">
                                            <input
                                                type="checkbox"
                                                name="isActive"
                                                className="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                                checked={formData.isActive}
                                                onChange={handleFormChange}
                                                disabled={loading.submitting}
                                            />
                                            <span className="text-sm font-medium text-gray-700">Set customer as active</span>
                                        </label>
                                    </div>
                                ) : (
                                    <div className="mb-4 sm:mb-6 p-3 bg-gray-50 rounded-lg">
                                        <div className="flex flex-col sm:flex-row sm:items-center gap-2">
                                            <span className="text-sm font-medium text-gray-700">Status:</span>
                                            <span className={`px-2 py-1 rounded-full text-xs font-medium inline-block w-fit ${
                                                selectedCustomer?.isActive
                                                    ? 'bg-green-100 text-green-700'
                                                    : 'bg-gray-100 text-gray-600'
                                            }`}>
                        {selectedCustomer?.isActive ? 'Active' : 'Inactive'}
                      </span>
                                            <span className="text-xs text-gray-500">(Status cannot be changed in edit mode)</span>
                                        </div>
                                    </div>
                                )}

                                {/* Form Actions - Sticky Bottom */}
                                <div className="sticky bottom-0 bg-white pt-4 border-t border-gray-200 -mx-4 sm:-mx-6 px-4 sm:px-6 pb-4 sm:pb-6">
                                    <div className="flex flex-col sm:flex-row gap-3">
                                        <button
                                            type="button"
                                            className="flex-1 px-6 py-3 rounded-lg font-semibold text-gray-700 bg-gray-200 hover:bg-gray-300 transition-colors disabled:opacity-50 text-sm sm:text-base"
                                            onClick={handleCloseModal}
                                            disabled={loading.submitting}
                                        >
                                            Cancel
                                        </button>

                                        <button
                                            type="submit"
                                            className="flex-1 px-6 py-3 rounded-lg font-semibold text-white shadow-lg transition-all disabled:opacity-50 text-sm sm:text-base"
                                            style={{ background: 'linear-gradient(135deg, #0613cc, #0613cc)' }}
                                            disabled={loading.submitting}
                                        >
                                            {loading.submitting ? (
                                                <>
                                                    <svg className="w-4 h-4 sm:w-5 sm:h-5 inline-block mr-2 -mt-0.5 animate-spin" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                                                    </svg>
                                                    Saving...
                                                </>
                                            ) : (
                                                <>
                                                    <svg className="w-4 h-4 sm:w-5 sm:h-5 inline-block mr-2 -mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4" />
                                                    </svg>
                                                    Save Customer
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Customers;